<template>
  <!-- 详情未登录 -->
  <div class="DetailsLogIn">
    <Head />

    <!-- 详情未登录的头部nav -->
    <DockingSystemHead />

    <!-- 项目标题部分 -->
    <BusinessDetailsTop :list="BusinessDetailsToplist" :msg="ProjectList" />

    <!-- 项目介绍部分 -->
    <BusinessDetailsCenter :loginType="loginType" :msg="ProjectList" />

    <!-- 项目热点新闻 -->
    <!-- <BusinessDetailsBottom :loginType="loginType" /> -->

    <Foot />

   
  </div>
</template>

<script>
import Head from "@/components/Head/Head.vue";
import Foot from "@/components/Foot/Foot.vue";
import DockingSystemHead from "@/components/DockingSystem/Head/DockingSystemHead.vue"; //推荐项目的头部nav
import BusinessDetailsTop from "@/components/DockingSystem/BusinessDetails/BusinessDetailsTop.vue"; //商家详情上部
import BusinessDetailsCenter from "@/components/DockingSystem/BusinessDetails/BusinessDetailsCenter.vue"; //商家详情中部
// import BusinessDetailsBottom from "@/components/DockingSystem/BusinessDetails/BusinessDetailsBottom.vue"; //商家详情底部

import axios from "axios"

export default {
  props: {},
  components: {
    Head,
    Foot,
    DockingSystemHead,
    BusinessDetailsTop,
    BusinessDetailsCenter,
    // BusinessDetailsBottom,
  },
  data() {
    return {
      // loginType:false,//登录状态,false为未登录
      loginType: true, //登录状态,true为已登录
      BusinessDetailsToplist: [
        {
          title: "医儿易",
          logoUrl: "../../../../public/static/images/yiErYi-logo.png",
          msg: "医儿易， 让孩子看病更容易",
          tags: ["医疗健康", "Pre-A", "北京市", "Pre-A", "2017年成立"],
        },
      ],
      ProjectList:{},//项目返回的信息
    };
  },
  created: function() {
    let id = this.$route.query.id;
      // console.log('this.$route', this.$route.query.id);
    this.getProjectList(id);
    //获取项目数据
  },
  methods: {
    getProjectList(id) {
        let self = this;
        //获取项目数据
        axios.get('/api/jointprojectdetails', {
          params: {
            id: id,//项目id
          }
        })
          .then(function (response) {
            if (response.data.code == 0) {
              self.ProjectList = response.data.data

            }
          })
          .catch(function (error) {
            console.log(error);
          });

      },
  },
};
</script>

<style scoped>
.DetailsLogIn {
}
</style>
